import React from "react";

import { Modal } from "../../../../../components/modal/Modal";
import { ADD_CONTACT_MODAL_WIDTH } from "../model/addContact.constants";

type AddContactFormFrameProps = {
  onBack: () => void;
  children: React.ReactNode;
};

export const AddContactFormFrame: React.FC<AddContactFormFrameProps> = ({
  onBack,
  children,
}) => {
  return (
    <Modal onClose={onBack} width={ADD_CONTACT_MODAL_WIDTH}>
      <div className={"-m-6 overflow-hidden rounded-2xl max-md:-m-4"}>
        {children}
      </div>
    </Modal>
  );
};
